<template>
    <div>
        <div :class="[statusColor,'mb-50 px-50 py-25 rounded']">{{ row.Status }}</div>
        <ul class="list-group">        
            <li class="list-group-item d-flex justify-content-between text-nowrap px-50 py-25"><strong>Banka</strong><span>{{  $safe(row,'BankAccount.Bank.BankName') || 'Bilinmiyor' }}</span></li>
            <li class="list-group-item d-flex justify-content-between text-nowrap px-50 py-25"><strong>Hesap</strong><span>{{ $safe(row,'BankAccount.Name') || 'Bilinmiyor' }}</span></li>
            <li class="list-group-item d-flex justify-content-between text-nowrap px-50 py-25"><strong>Hesap Numarası</strong><span>{{ $safe(row,'BankAccount.AccountNumber') || 'Bilinmiyor' }}</span></li>
            <li class="list-group-item d-flex justify-content-between text-nowrap px-50 py-25"><strong>Banka Başarılı Kayıt</strong><span>{{ row.SucceededEntry || 'Bilinmiyor' }}</span></li>
            <li class="list-group-item d-flex justify-content-between text-nowrap px-50 py-25"><strong>Banka Başarısız Kayıt</strong><span>{{ row.FailedEntry || 'Bilinmiyor' }}</span></li>
            <li class="list-group-item d-flex justify-content-between text-nowrap px-50 py-25"><strong>Banka Toplam Kayıt</strong><span>{{ row.TotalEntry || 'Bilinmiyor' }}</span></li>
            <li class="list-group-item d-flex justify-content-between text-nowrap px-50 py-25"><strong>Banka Toplam Tutar <feather-icon class="text-warning ml-50 mb-20" icon="InfoIcon" v-b-tooltip.noninteractive.hover.bottom="'Bankadan gelen e-postadaki toplam tutar'"></feather-icon></strong><span>{{ row.BankTotalAmountStr || 'Bilinmiyor' }}</span></li>
            <li class="list-group-item d-flex justify-content-between text-nowrap px-50 py-25"><strong>Dosya Toplam Tutar <feather-icon class="text-warning ml-50 mb-20" icon="InfoIcon" v-b-tooltip.noninteractive.hover.bottom="'Tarafınızca TMS aracılığıyla oluşturulan dosyadaki toplam tutar'"></feather-icon></strong><span>{{ row.FileTotalAmountStr || 'Bilinmiyor' }}</span></li>
        </ul>
    </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue'

export default {
    props:{
        row:Object,
        field:Object
    },
    directives:{
        'b-tooltip':VBTooltip
    },
    computed:{
        statusColor(){
            switch(this.row.StatusId){
                case 0: return 'bg-light-warning text-warning';
                case 1: return 'bg-light-warning text-warning';
                case 2: return 'bg-light-secondary text-secondary';
                case 3: return 'bg-light-primary text-primary';
                case 4: return 'bg-light-danger text-danger';
                case 5: return 'bg-light-danger text-danger';
                case 6: return 'bg-light-success text-success';
                case 7: return 'bg-light-info text-info';
                case 8: return 'bg-light-danger text-danger';
                case 9: return 'bg-light text-muted'
                case 10: return 'bg-light-info text-info'
                case 11: return 'bg-light-danger text-danger'
                case 12: return 'bg-light-secondary text-secondary'
            }
        }
    }
}
</script>

<style>

</style>